<script>
import options from './LegalText.options'
export default options
</script>

<template></template>
